import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {LocationsDataService} from '@on-the-go-web/library/helpers';

// Guards the `l/:locationId` route group. Only redirects away when we can be
// sure the id doesn't belong to the account (locations have loaded and it's
// not among them) — while locations are still loading, we let the navigation
// through and rely on the page components' own per-id fetch/loading state,
// the same way the rest of the app already tolerates that race.
export const locationContextGuard: CanActivateFn = (route) => {
  const locationsDataService = inject(LocationsDataService);
  const router = inject(Router);

  const locationId = route.paramMap.get('locationId');
  if (!locationId) {
    return router.parseUrl('/');
  }

  const locations = locationsDataService.locations();
  if (locations !== undefined && !locations.some((location) => location.id === locationId)) {
    return router.parseUrl('/');
  }

  locationsDataService.recordLocationUsed(locationId);
  return true;
};
